import { useEffect, useState } from "react";

import { getRemoteConfig } from "/util/countly";
import { SummitMigrationModal } from "/util/countly/types";

const useSystemMessageModal = () => {
  const [modalEnabled, setModalEnabled] = useState<SummitMigrationModal>({ enabled: false });

  useEffect(() => {
    const remoteConfig = getRemoteConfig();
    const value = remoteConfig.summit_migration_modal;

    if (value) {
      setModalEnabled(value);
    }
  }, []);

  return {
    enabled: modalEnabled?.enabled,
  };
};

export default useSystemMessageModal;
